import type { ReactNode } from 'react'
import { tv } from 'tailwind-variants'

import { Loader } from '@/components'
import { Swatch } from './Swatch'

// The base pill slots. A domain extends this with its own statuses and passes the
// resolved slots plus a label; the primitive knows no domain.
export const statusBadgeVariants = tv({
  slots: {
    base: 'inline-flex items-center gap-2 px-2.5 py-1 rounded-full border text-xs font-medium transition-colors cursor-default select-none bg-neutral-100 text-neutral-600 border-neutral-200 hover:bg-neutral-150',
    dot: 'bg-neutral-400',
    icon: '',
  },
})

interface StatusBadgeSlots {
  base: (options?: { className?: string }) => string
  dot: () => string
  icon: () => string
}

interface StatusBadgeProps {
  slots: StatusBadgeSlots
  label: ReactNode
  animated?: boolean
  className?: string
  showLabel?: boolean
}

export const StatusBadge = ({
  slots,
  label,
  animated = false,
  className,
  showLabel = true,
}: StatusBadgeProps) => (
  <div className={slots.base({ className })}>
    <div className="relative flex items-center justify-center">
      {animated ? (
        <Loader className={slots.icon()} />
      ) : (
        <Swatch className={slots.dot()} />
      )}
    </div>
    {showLabel && <span className="relative">{label}</span>}
  </div>
)
